export default __webpack_public_path__ + "static/media/36I-102788_-15910_0.1a81cc20.jpg";